import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { Box } from "@mui/material";

type Props = { color?: string; iconColor?: string; size?: number };

const DUMMY_TEXT = "halslldchlki";

export const RedactedBalance = ({
  color = "grey.500",
  iconColor = "grey.700",
  size = 4,
}: Props) => {
  const blur = `${size}px`;

  return (
    <Box display="flex" alignItems="center" aria-hidden aria-label="Nedostupné">
      <Box position="relative">
        <Box
          width="100%"
          sx={({ spacing }) => ({
            color,
            filter: `blur(${blur})`,
            fontSize: spacing(size),
            pointerEvents: "none",
            userSelect: "none",
            wordBreak: "keep-all",
          })}
        >
          {DUMMY_TEXT}
        </Box>
        <VisibilityOffOutlinedIcon
          fontSize="small"
          sx={({ spacing }) => ({
            left: "50%",
            top: "55%", // looks better than real center
            transform: "translate(-50%, -50%)",
            alignSelf: "center",
            position: "absolute",
            color: iconColor,
            height: spacing(size),
          })}
        />
      </Box>
    </Box>
  );
};
